import React from 'react';
import {
    Chart as ChartJS,
    ArcElement,
    Tooltip,
    Legend,
  } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';
import ChartDataLabels from "chartjs-plugin-datalabels";
import './Chart.css';

ChartJS.register(
    ArcElement,
    Tooltip,
    Legend,
    ChartDataLabels
);

export default function DoughnutChart(props) {
  return(
    <div height={props.hChart+"px"} style={{"height": props.hChart, "minHeight": "100px"}}>
        <Doughnut id={props.id} options={props.options} data={props.chartData.data} className="canvasChart"/>
    </div>
  );
}

//<Bar options={props.chartData.options} data={props.chartData.data} />